module.exports = __webpack_public_path__ + "assets/img/copy2.bab47196.png";